module.exports = __webpack_public_path__ + "img/szh5.8076aefd.jpg";